'use strict';
var React = require('react');
import axios from 'axios';
var BaseClassComponent = require('../../shared/base.jsx');
var EnumCoreModule = require('../../../../src/public/js/enum-core.js');
var AddressSettingsButton = require(`./address-settings-button`);
const client = require('../../../../sdk/client');

var Toastr = require('toastr');

class AddressSettingsComponent extends BaseClassComponent {
    constructor(props) {
        super(props);
        this.state = {
            CountryCode: 'MX',
            FirstName: '',
            states: [],
            cities: [],
            selectedState: '',
            selectedCity: '',
            Suburb: '',
            Street: '',
            NumExt: '',
            NumInt: '',
            typeAddress: '',
        };
        this.onChange = this.onChange.bind(this);
        this.Cookies_SelectedAlias = 'SelectedAlias';
        this.Cookies_SelectedAddress = 'SelectedAddress';
        this.Cookies_SelectedState = 'SelectedState';
        this.Cookies_SelectedCity = 'SelectedCity';
        this.Cookies_SelectedZipcode = 'SelectedZipcode';
        this.Cookies_SelectedAddressLider = 'SelectedCustomAddress';
        this.Cookies_SelectedAddressRegion = 'SelectedCustomAddressRegion';
        this.Cookies_SelectedAddressPedido = 'SelectedCustomPedido';
        this.Cookies_SelectedAddressJSON = 'SelectedAddressJSON';
        this.Cookies_SelectedAddressDepot = 'SelectedAddressDepot';
        this.Cookies_SelectedAddressLatitude = 'SelectedAddressLatitude';
        this.Cookies_SelectedAddressLongitude = 'SelectedAddressLongitude';
    }

    componentDidMount() {
        this.fetchStates();
    }

    getCookie(name) {
        if(typeof window !== 'undefined'){
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            if (parts.length === 2) {
            return parts.pop().split(';').shift();
            }
            return null;
        }
    }

    fetchStates = async () => {
        try {
            const response = await axios.get(`https://api.copomex.com/query/get_estados?token=${process.env.API_TOKEN_COPOMEX}`);
            this.setState({ states: response.data.response.estado });
            // console.log ("State:", this.state.states)
        } catch (error) {
            console.error('Error fetching states:', error);
        }
    };

    fetchCities = async (stateName) => {
        try {
            const response = await axios.get(`https://api.copomex.com/query/get_municipio_por_estado/${stateName}?token=${process.env.API_TOKEN_COPOMEX}`);
            this.setState({ cities: response.data.response.municipios.sort() });
            // console.log("City:", this.state.cities)
        } catch (error) {
            console.error('Error fetching cities:', error);
        }
    };

    handleStateChange = async (event) => {
        const selectedState = event.target.value;
        this.setState({ selectedState }); // Set the selected state

        try {
            const response = await axios.get(`https://api.copomex.com/query/get_municipio_por_estado/${selectedState}?token=${process.env.API_TOKEN_COPOMEX}`);
            const cities = response.data.response.municipios.sort();
            this.setState({ 
                cities: cities, 
                selectedCity: cities.length > 0 ? cities[0] : '' // Set the first city as the selected city
            });
        } catch (error) {
            console.error('Error fetching cities:', error);
            this.setState({ cities: [], selectedCity: '' }); // Clear cities and selected city in case of an error
        }
    };
    
    handleCityChange = (event) => {
        this.setState({ selectedCity: event.target.value });
    };

    constants() {
        return elements = {
            AddressTab: 'AddressTab',
            AddresBox: 'AddresBox'
        };
    }

    hideShowAddressTabContainer() {
        let returnClass = 'address-tab full-width';

        if (this.props.addresses && this.props.addresses.length > 0) {
            returnClass = returnClass + " hide-me";
        }
        return returnClass;
    }

    hideShowAddressBoxContainer() {
        let returnClass = 'setting-address-box full-width';

        if (!this.props.addresses || this.props.addresses.length < 1) {
            returnClass = returnClass + " hide-me";
        }

        return returnClass;
    }

    hideElement(element) {
        $('#encodeContainer').removeClass('hide-me');
        $('#boxContainer').removeClass('hide-me');

        if (element == "AddressTab") {
            $('#encodeContainer').addClass('hide-me');
        } else {
            $('#boxContainer').addClass('hide-me');
        }
    }

    validateAddress() {
        const requiredFields = ['Alias', 'FirstName', 'LastName', 'Suburb', 'Street', 'NumExt', 'selectedState', 'selectedCity', 'PostCode'];
        const emptyFields = [];
    
        for (const field of requiredFields) {
            if (!this.state[field]) {
                emptyFields.push(field);
            }
        }
    
        if (emptyFields.length > 0) {
            Toastr.error('Debes completar todos los campos para crear la direccion');
            return false;
        }

        return true;
    }

    /*---------------------------------------------------------------------
                            Trigger Actions
    ---------------------------------------------------------------------*/

    setCookiesWhenUpdateSelectedAddress(
        alias,
        selectedAddress,
        selectedState,
        selectedCity,
        selectedZipCode,
        selectedAddressLatitude,
        selectedAddressLongitude,
        selectedAddressJSON
    ){
        document.cookie = `${this.Cookies_SelectedAlias}=${ alias }; path=/`;
        document.cookie = `${this.Cookies_SelectedAddress}=${ selectedAddress }; path=/`;
        document.cookie = `${this.Cookies_SelectedState}=${ selectedState }; path=/`;
        document.cookie = `${this.Cookies_SelectedCity}=${ selectedCity }; path=/`;
        document.cookie = `${this.Cookies_SelectedZipcode}=${ selectedZipCode }; path=/`;
        document.cookie = `${this.Cookies_SelectedAddressLatitude}=${ selectedAddressLatitude }; path=/`;
        document.cookie = `${this.Cookies_SelectedAddressLongitude}=${ selectedAddressLongitude }; path=/`;
        document.cookie = `${this.Cookies_SelectedAddressJSON}=${ selectedAddressJSON }; path=/`;
    }

    async getLatLongAPI(number, street, postalCode){
        try {
            const apiLatitudeAndLongitude = `https://api.copomex.com/query/info_cp_geocoding/${postalCode}?type=simplified&calle=${street}&numero=${number}&token=${process.env.API_TOKEN_COPOMEX}`;
        
            const response = await axios.get(apiLatitudeAndLongitude);
            const latitudeApi = response?.data?.response?.geocoding ? response?.data?.response?.geocoding[0]?.lat : 0;
            const longitudeApi = response?.data?.response?.geocoding ? response?.data?.response?.geocoding[0]?.long : 0;

            return {
                latitudeApi,
                longitudeApi
            }
        } catch (error) {
            return Toastr.error("Ha ocurrido un error al actualizar tu dirección, por favor revisa que la información sea correcta.")
        }
        
    }

    async addAddress(e) {
        var self = this;
        var isValid = self.validateAddress();

        if (isValid) {
            var $this = $(e.target);
            var $parent = $this.parents(".address-tab");
            if (!$parent.find(".error-con").length) {            
                $('.buttons-add-address').prop('disabled', true);
                var boolIsA_Deliv = false;
                if(self.state['typeAddress'] === "Dirección de envío"){
                    boolIsA_Deliv = true;
                }

                var addressId = this.props.matriz[0].DireccionFacturacionId;
                if(boolIsA_Deliv){
                    addressId = this.props.matriz[0].DireccionId;
                }

                let { latitudeApi, longitudeApi } = await this.getLatLongAPI(self.state.NumExt, self.state.Street, self.state.PostCode);

                const promiseSucursales = new Promise((resolve, reject) => {
					const options = {
						pluginId: process.env.ADMINISTRACION_ALMACENES,
						tableName: "Almacenes",
                        query: [
                            {
                                Name: 'IsActive',
                                Operator: "eq",
                                Value: "true"
                            }
                        ]
					};
					
					client.CustomTables.searchCustomTable(options, function (err, result) {
						if (err) {
							reject(err);
					} else {
							resolve(result);
						}
					});
				});

                const result = await promiseSucursales;
                const almacenes = result.Records;

                var distances = {};
                almacenes.forEach(almacen => {
                    const radioTierra = 6371; 
    
					const radianesLat1 = (latitudeApi * Math.PI) / 180;
					const radianesLon1 = (longitudeApi * Math.PI) / 180;
					const radianesLat2 = (almacen.Latitud * Math.PI) / 180;
					const radianesLon2 = (almacen.Longitud * Math.PI) / 180;
						
					const dLat = radianesLat2 - radianesLat1;
			    	const dLon = radianesLon2 - radianesLon1;
						
					const a =
						Math.sin(dLat / 2) ** 2 +
						Math.cos(radianesLat1) * Math.cos(radianesLat2) * Math.sin(dLon / 2) ** 2;
					const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
						
					const distance = radioTierra * c;
                    distances[almacen.Estado] = distance;
                });

                var keys  = Object.keys(distances).sort(function(a,b) { return distances[a] - distances[b]; });
                var match = keys.filter(function(x) { return distances[x] === distances[keys[0]]; });

                const sucursales = {
                    "Chihuahua": 2807,
                    "Zacatecas": 2933,
                    "Coahuila": 2819,
                    "Colima": 2729,
                    "Jalisco": 2886,
                    "Puebla": 2848,
                    "Oaxaca": 2839,
                    "Veracruz": 1992,
                    "Sinaloa": 1852,
                    "Sonora": 2702,
                    "Chiapas": 2766,
                    "Tabasco": 2766,
                    "Yucatán": 2713,
                    "Quintana Roo": 2859
                };

                let vendedorId = null;
                if (sucursales[match]) {
                    vendedorId = sucursales[match];
                } else {
                    vendedorId = "No se encontró";
                }
                
                let jsonSpecialInstructions = {
                    "addressID": addressId,
                    "notifications": this.props.matriz[0].EmailNotification,
                    "vendedorId": vendedorId
                }

                var myJSON = JSON.stringify(jsonSpecialInstructions);

                var newAddress = Object.assign({}, self.state, {
                    "Name": self.state['FirstName'] + '|' + self.state['LastName'],
                    Delivery: true,
                    Pickup: boolIsA_Deliv,
                    "State": self.state.selectedState,
                    "City": self.state.selectedCity,
                    "Latitude": latitudeApi,
                    "Longitude": longitudeApi,
                    "Line1": `${self.state.Suburb}, ${self.state.Street}, ${self.state.NumExt}, ${self.state.NumInt}`,
                    "Line2": self.state['Alias'],
                    "SpecialInstructions": myJSON
                });        

                self.props.createAddress((newAddress));

                self.setState({
                    Alias: '',
                    addressID: '',
                    FirstName: '',
                    LastName: '',
                    Line1: '',
                    Suburb: '',
                    Street: '',
                    NumExt: '',
                    NumInt: '',
                //    CountryCode: '',
                    State: '',
                    City: '',
                    PostCode: '',
                }, function () {

                });

                setTimeout( function() {
                    $('#modalAddAddress').modal('hide');
                    $('.buttons-add-address').prop('disabled', false);
                }, 3000);            
            } 
        } else {
            return false;
        }
    }

    async updateAddress(e) {
        e.preventDefault();
        var self = this;
        var isValid = self.validateAddress();

        if (isValid) {
            var boolIsA_Deliv = false;
            if(self.state['typeAddress'] === "Dirección de envío"){
                boolIsA_Deliv = true;
            }
            
            var addressId = this.props.matriz[0].DireccionFacturacionId;
            if(boolIsA_Deliv){
                addressId = this.props.matriz[0].DireccionId;
            }

            let { latitudeApi, longitudeApi } = await this.getLatLongAPI(self.state.NumExt, self.state.Street, self.state.PostCode);

            const promiseSucursales = new Promise((resolve, reject) => {
				const options = {
					pluginId: process.env.ADMINISTRACION_ALMACENES,
					tableName: "Almacenes",
                    query: [
                        {
                            Name: 'IsActive',
                            Operator: "eq",
                            Value: "true"
                        }
                    ]
				};
					
				client.CustomTables.searchCustomTable(options, function (err, result) {
					if (err) {
						reject(err);
				} else {
						resolve(result);
					}
				});
			});

            const result = await promiseSucursales;
            const almacenes = result.Records;

            var distances = {};
            almacenes.forEach(almacen => {
                const radioTierra = 6371; 
    
				const radianesLat1 = (latitudeApi * Math.PI) / 180;
				const radianesLon1 = (longitudeApi * Math.PI) / 180;
				const radianesLat2 = (almacen.Latitud * Math.PI) / 180;
				const radianesLon2 = (almacen.Longitud * Math.PI) / 180;
						
				const dLat = radianesLat2 - radianesLat1;
		    	const dLon = radianesLon2 - radianesLon1;
						
				const a =
					Math.sin(dLat / 2) ** 2 +
					Math.cos(radianesLat1) * Math.cos(radianesLat2) * Math.sin(dLon / 2) ** 2;
				const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
					
				const distance = radioTierra * c;
                distances[almacen.Estado] = distance;
            });

            var keys  = Object.keys(distances).sort(function(a,b) { return distances[a] - distances[b]; });
            var match = keys.filter(function(x) { return distances[x] === distances[keys[0]]; });

            const sucursales = {
                "Chihuahua": 2807,
                "Zacatecas": 2933,
                "Coahuila": 2819,
                "Colima": 2729,
                "Jalisco": 2886,
                "Puebla": 2848,
                "Oaxaca": 2839,
                "Veracruz": 1992,
                "Sinaloa": 1852,
                "Sonora": 2702,
                "Chiapas": 2766,
                "Tabasco": 2766,
                "Yucatán": 2713,
                "Quintana Roo": 2859
            };

            let vendedorId = null;
            if (sucursales[match]) {
                vendedorId = sucursales[match];
            } else {
                vendedorId = "No se encontró";
            }

            let jsonSpecialInstructions = {
                "addressID": addressId,
                "notifications": this.props.matriz[0].EmailNotification,
                "vendedorId": vendedorId
            }

            var myJSON = JSON.stringify(jsonSpecialInstructions);

            if(self.state.selectedAddressToEdit == this.getCookie('SelectedAddress')){
                self.setCookiesWhenUpdateSelectedAddress(
                    self.state['Alias'],
                    self.state.selectedAddressToEdit,
                    self.state.selectedState,
                    self.state.selectedCity,
                    self.state.PostCode,
                    latitudeApi,
                    longitudeApi,
                    myJSON
                )
            }

            var newAddress = Object.assign({}, {
                "ID": self.state.selectedAddressToEdit,
                "Name": self.state['FirstName'] + '|' + self.state['LastName'],
                "Line1": `${self.state.Suburb}, ${self.state.Street}, ${self.state.NumExt}, ${self.state.NumInt}`,
                "Line2": self.state['Alias'],
                "PostCode": self.state.PostCode,
                "Latitude": latitudeApi,
                "Longitude": longitudeApi,
                Delivery: true,
                Pickup: boolIsA_Deliv,
                "SpecialInstructions": myJSON,
                "State": self.state.selectedState,
                "City": self.state.selectedCity,
                "Country": "Mexico",
                "CountryCode": "MX",
            });
            
            self.props.updateAddress(self.state.selectedAddressToEdit, newAddress);

            self.setState({
                Alias: '',
                addressID: '',
                FirstName: '',
                LastName: '',
                Line1: '',
                Suburb: '',
                Street: '',
                NumExt: '',
                NumInt: '',
            //    CountryCode: '',
                State: '',
                City: '',
                PostCode: '',
            }, function () {

            });

            setTimeout( function() {
                $('#modalEditAddress').modal('hide');            
                location.reload();
            }, 3000);   
            return false;
        } else {
            return false;
        }
    }

    doAddressDelete(e) {
        var self = this;
        self.props.deleteAddress(self.state.selectedAddressToDelete);

        setTimeout( function() {
            $('#modalEditAddress').modal('hide');            
            location.reload();
        }, 1000);   
    }

    resetAddAddress(){        
        $('.buttons-add-address').prop('disabled', false);    
    }

    showEditAddress(id,address,name,lastName) {
        var self = this;
        $('#modalEditAddress').modal('show');        
        
        let addressType = address.Pickup ? "Dirección de envío" : "Dirección de facturación";
        var special = address.SpecialInstructions;
        var obj = jQuery.parseJSON(special);
        // let addressID = obj.addressID != undefined ? obj.addressID: '';
        let addressID = (obj?.addressID) ?? '';
        const addressInfo = address.Line1.split(',').map(valor => valor.trim());
        const suburb = addressInfo[0];
		const street = addressInfo[1];
		const extNumber = addressInfo[2];
		const intNumber = addressInfo[3];
        self.fetchStates();
        self.setState({
                selectedAddressToEdit: address.ID,
                Alias: address.Line2,
                addressID: addressID,
                typeAddress: addressType,
                FirstName: name,
                LastName: lastName,
                Line1: address.Line1,
                Suburb: suburb,
                Street: street,
                NumExt: extNumber,
                NumInt: intNumber,
                // CountryCode: '',
                selectedState: address.State,
                selectedCity: address.City,
                PostCode: address.PostCode,
                }, () => {
                    self.fetchCities(address.State);
                });
    }

    showDeleteAddress(id) {
        $('#modalRemove').modal('show');

        this.setState({
            selectedAddressToDelete: id
        }, function () {
        });
    }

    hideEditAddress(){
        var self = this;
        
        self.setState({
            Alias: '',
            addressID: '',
            typeAddress: '',
            FirstName: '',
            LastName: '',
            Line1: '',
        //    CountryCode: '',
            State: '',
            City: '',
            PostCode: '',
        }, function () {

        });

        $('#modalEditAddress').modal('hide');

    }

    validateFieldsAddress() {
        $(".error-con").removeClass("error-con");
        $('.required.error-con').removeClass("error-con");
        $(".required").each(function (index, element) {
            var $this = $(element);
          
            $this.removeClass("error-con");
        
            if ($this.val() == "" && $this.val().length < 1) {
                $this.addClass("error-con");
             //   Toastr.warning('Completa los campos para guardar', 'Campos requeridos');
            }
            if ($this.val() == "Selecciona tipo de dirección") {
                $this.addClass("error-con");
            }
            
        })
    }

    showAddressList(typeofAddresss) {
        function showFirst(name) {
            if (name == null)
                return ''

            if (name.indexOf('|') > 0) {
                return name.split('|')[0]
            }
            return name
        }

        function showSecond(name) {

            if (name == null)
                return ''

            if (name.indexOf('|') > 0) {
                return name.split('|')[1]
            }
            return ''
        }

        function addSelectedClass(id) {
            $('[data-address-id]').removeClass('selected')
            $('[data-address-id="' + id + '"]').addClass('selected')
        }

        function showHideDeleteAddress(index,addressID) {
            if (index == 0)
                return ''
            else
                return (<button className='btn btn-danger' type="button" onClick={(e) => self.showDeleteAddress(addressID)} ><i className="fa fa-trash" /></button>)
        }

        function showHideEditAddress(index,addressID,address,name,lastName) {
            return (<button className="btn btn-primary" onClick={(e) => self.showEditAddress(addressID,address,name,lastName)} ><i className="fa fa-edit" /></button>)
        }
        
        var self = this;
        const userDetail = self.props.user;
        var tipoCliente = 'B2B';
        if(userDetail) {
            if(userDetail.CustomFields) {
                if(userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario")) {
                    tipoCliente  = userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0];
                }
            }
        }
        if (this.props.addresses && this.props.addresses.length > 0) {
            return (
                this.props.addresses.map(function (addr, index) {
                    
                    /*
                    if (addr.Pickup != false)
                        return ''
                    */
                    if (addr.Pickup === typeofAddresss){
                                {/*<div key={addr.ID} onClick={(e) => addSelectedClass(addr.ID)} data-address-id={addr.ID} className="pdcb-address-box  parent-r-b onboarder-address" style={{ 'height': '250px' }}>*/}
                            return (
                                <div key={addr.ID}  data-address-id={addr.ID} className="pdcb-address-box  parent-r-b onboarder-address profile-address-container" style={{ 'height': '280px' }}>
                                    <span className="pdcb-detail">
                                        <p>{addr.Line2}</p>
                                        <p>{showFirst(addr.Name)}</p>
                                        <p>{showSecond(addr.Name)}</p>
                                        {/*<p style={{fontWeight: 'bold'}}>{addr.Pickup ? "Dirección de envío" : "Dirección de facturación"}:</p>*/}
                                        <p>{addr.Line1}</p>
                                        <p>{addr.City}{addr.State == null || addr.State == '' ? '' : ', ' + addr.State}</p>
                                        <p>{addr.Country}</p>
                                        <p>{addr.PostCode}</p>
                                    </span>
                                    {tipoCliente ==='B2C' ? (
                                        <div className='btn-group-address'>
                                            {
                                                showHideDeleteAddress(index, addr.ID)
                                            }
                                            {
                                                showHideEditAddress(index, addr.ID, addr, showFirst(addr.Name), showSecond(addr.Name))
                                            }
                                        </div>
                                    ) : (
                                        <div className='btn-group-address'>
                                        </div>
                                    )}
                                </div >
                            );
                    }
                })
            );
        } else
            return '';
    }

    renderCountry() {
        var countries = []
        
        EnumCoreModule.GetCountries().map(function (country) {
            countries.push({
                name: country.name,
                alpha2code: country.alpha2code
            })
          //  countries.push(country.name)
        })

        countries = countries.sort();

        return countries.map(function (country) {
         //   let theCountry = EnumCoreModule.GetCountries().filter(d => d.name == country);
            
            return (
                <option key={country.alpha2code} value={country.alpha2code}>{country.name}</option>
            );
        })
    }

    /*---------------------------------------------------------------------
                                Modals
    ---------------------------------------------------------------------*/

    renderAddAddressModal(){
        let self = this;
        // let states = this.props.uniqueWarehouses;
        // states = [...states].sort((a, b) =>
        //     a.Estado > b.Estado ? 1 : -1,
        // );
        return(
            <div id="modalAddAddress" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="form-group row">
                                <div className="col-xs-12">
                                    <h4 className="modal-title">Añadir dirección</h4>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12">                                        
                                    <span className="title lbl-profile">Alias</span>
                                    <input type="text" className="input-text get-text required input-address-sec form-control alias" name="alias" data-react-state-name="Alias" data-react-state-component-name="Address" defaultValue={self.state.Alias} onChange={self.onChange} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Nombre</span>
                                    <input id="input-address-name" type="text" className="input-text get-text required input-address-sec form-control Firstname" name="Firstname" data-react-state-name="FirstName" data-react-state-component-name="Address" defaultValue={self.state.FirstName} onChange={self.onChange} />
                                </div>
                                <div className="col-xs-12 col-md-6">                                        
                                    <span className="title lbl-profile">Apellido</span>
                                    <input id="input-address-last" type="text" className="input-text get-text required input-address-sec form-control" name="last" data-react-state-name="LastName" data-react-state-component-name="Address" defaultValue={self.state.LastName} onChange={self.onChange} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12">
                                    <span className="title lbl-profile">Tipo de dirección</span>
                                    <select id="select-type-address" className="sassy-select get-text required form-control" data-react-state-name="typeAddress" data-react-state-component-name="Address" defaultValue={self.state.typeAddress} onChange={self.onChange}>
                                        <option>Selecciona tipo de dirección</option>
                                        <option value={"Dirección de envío"}>Dirección de envío</option>
                                        <option value={"Dirección de facturación"}>Dirección de facturación</option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Colonia</span>
                                    <input id="input-address-suburb" type="text" className="input-text get-text required input-address-sec form-control" name="Suburb" data-react-state-name="Suburb" data-react-state-component-name="Address" defaultValue={self.state.Suburb} onChange={self.onChange} />
                                </div>
                                <div className="col-xs-12 col-md-6">                                        
                                    <span className="title lbl-profile">Calle</span>
                                    <input id="input-address-street" type="text" className="input-text get-text required input-address-sec form-control" name="Street" data-react-state-name="Street" data-react-state-component-name="Address" defaultValue={self.state.Street} onChange={self.onChange} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Número exterior</span>
                                    <input id="input-address-numExt" type="text" className="input-text get-text required input-address-sec form-control" name="NumExt" data-react-state-name="NumExt" data-react-state-component-name="Address" defaultValue={self.state.NumExt} onChange={self.onChange} />
                                </div>
                                <div className="col-xs-12 col-md-6">                                        
                                    <span className="title lbl-profile">Número interior</span>
                                    <input id="input-address-numInt" type="text" className="input-text get-text required input-address-sec form-control" name="NumInt" data-react-state-name="NumInt" data-react-state-component-name="Address" defaultValue={self.state.NumInt} onChange={self.onChange} />
                                </div>
                            </div>                               
                            <div className="form-group row">
                                <div className="col-xs-12">
                                    <span className="title lbl-profile">Dirección Completa</span>
                                    <input type="text" placeholder="Dirección" className="hide-me input-text get-text required input-address-sec form-control" name="address" data-react-state-name="Line1" data-react-state-component-name="Address" defaultValue={self.state.Line1} onChange={self.onChange} />
                                </div>
                                {/* <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Dirección ID</span>
                                    <input type="text" className="input-text get-text required input-address-sec form-control" name="addressID" data-react-state-name="addressID" data-react-state-component-name="Address" defaultValue={self.state.addressID} value={self.state.addressID} onChange={self.onChange} />
                                </div> */}
                            </div>  
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">País</span>
                                    <select name="country" className="get-text required input-address-sec form-control" data-react-state-name="CountryCode" data-react-state-component-name="Address" defaultValue={self.state.CountryCode} onChange={self.onChange} disabled>
                                        <option value="">Selecciona tu país</option>
                                        {
                                            this.renderCountry()
                                        }
                                    </select>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Estado</span>
                                    <select className="input-text get-text input-address-sec form-control" name="state" data-react-state-name="State" data-react-state-component-name="Address" defaultValue={this.state.State} value={this.state.selectedState} onChange={this.handleStateChange}>
                                        <option defaultValue="">Seleccione el estado</option>
                                        {this.state.states.map((state, index) => (
                                            <option key={index} value={state}>{state}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Ciudad</span>
                                    <select className="input-text get-text required input-address-sec form-control" name="City" data-react-state-name="City" data-react-state-component-name="Address" defaultValue={self.state.City} value={this.state.selectedCity} onChange={this.handleCityChange}>
                                        <option value="">Seleccione la ciudad</option>
                                        {this.state.cities.map((city, index) => (
                                            <option key={index} value={city}>{city}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Código Postal</span>
                                    <input type="text" className="input-text get-text required input-address-sec" name="postal_code" data-react-state-name="PostCode" data-react-state-component-name="Address" defaultValue={self.state.PostCode} onChange={self.onChange} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button className="btn buttons-add-address btn-cancel-add-address" data-dismiss="modal">
                                Cancelar
                            </button>
                            <button className="btn buttons-add-address btn-add-address" id="addAddress" onClick={(e) => self.addAddress(e)}>
                                Agregar
                            </button>                                
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderEditAddressModal(){
        let self = this;
        // let states = this.props.uniqueWarehouses;
        // states = [...states].sort((a, b) =>
        //     a.Estado > b.Estado ? 1 : -1,
        // );
        const setupEditModal = (address) => {
        self.fetchStates(); 
        self.setState({
            selectedState: address.State,
            selectedCity: address.City,
        }, () => {
            self.fetchCities(address.State);
        });
    };
        return(
            <div id="modalEditAddress" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="form-group row">
                                <div className="col-xs-12">
                                    <h4 className="modal-title">Editar dirección</h4>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12">                                        
                                    <span className="title lbl-profile">Alias</span>
                                    <input type="text" className="input-text get-text required input-address-sec form-control" name="alias" data-react-state-name="Alias" data-react-state-component-name="Address" defaultValue={self.state.Alias} onChange={self.onChange} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Nombre</span>
                                    <input id="input-address-name" type="text" className="input-text get-text required input-address-sec form-control" name="first_name" data-react-state-name="FirstName" data-react-state-component-name="Address" defaultValue={self.state.FirstName} onChange={self.onChange} />
                                </div>
                                <div className="col-xs-12 col-md-6">                                        
                                    <span className="title lbl-profile">Apellido</span>
                                    <input id="input-address-last" type="text" className="input-text get-text required input-address-sec form-control" name="last" data-react-state-name="LastName" data-react-state-component-name="Address" defaultValue={self.state.LastName} onChange={self.onChange} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12">
                                    <span className="title lbl-profile">Tipo de dirección</span>
                                    <select id="select-type-address" className="sassy-select get-text required form-control" data-react-state-name="typeAddress" data-react-state-component-name="Address" onChange={self.onChange} disabled>
                                        <option>Selecciona tipo de dirección</option>
                                        <option
                                            value={"Dirección de envío"}
                                            selected={self.state.typeAddress === "Dirección de envío"}
                                        >
                                            Dirección de envío
                                        </option>
                                        <option
                                            value={"Dirección de facturación"}
                                            selected={self.state.typeAddress === "Dirección de facturación"}
                                        >
                                            Dirección de facturación
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Colonia</span>
                                    <input id="input-address-suburb" type="text" className="input-text get-text required input-address-sec form-control" name="Suburb" data-react-state-name="Suburb" data-react-state-component-name="Address" defaultValue={self.state.Suburb} onChange={self.onChange} />
                                </div>
                                <div className="col-xs-12 col-md-6">                                        
                                    <span className="title lbl-profile">Calle</span>
                                    <input id="input-address-street" type="text" className="input-text get-text required input-address-sec form-control" name="Street" data-react-state-name="Street" data-react-state-component-name="Address" defaultValue={self.state.Street} onChange={self.onChange} />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Número exterior</span>
                                    <input id="input-address-numExt" type="text" className="input-text get-text required input-address-sec form-control" name="NumExt" data-react-state-name="NumExt" data-react-state-component-name="Address" defaultValue={self.state.NumExt} onChange={self.onChange} />
                                </div>
                                <div className="col-xs-12 col-md-6">                                        
                                    <span className="title lbl-profile">Número interior</span>
                                    <input id="input-address-numInt" type="text" className="input-text get-text required input-address-sec form-control" name="NumInt" data-react-state-name="NumInt" data-react-state-component-name="Address" defaultValue={self.state.NumInt} onChange={self.onChange} />
                                </div>
                            </div>                                 
                            <div className="form-group row">
                                <div className="col-xs-12">
                                    <span className="title lbl-profile">Dirección Completa</span>
                                    <input type="text" placeholder="Dirección" className="hide-me input-text get-text required input-address-sec form-control" name="address" data-react-state-name="Line1" data-react-state-component-name="Address" defaultValue={self.state.Line1} onChange={self.onChange} />
                                    <input type="text" className="hide-me" name="addressID" data-react-state-name="addressID" data-react-state-component-name="Address" defaultValue={self.state.addressID} onChange={self.onChange} />
                                </div>
                                {/* <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Dirección ID</span>
                                    <input type="text" className="input-text get-text required input-address-sec form-control" name="addressID" data-react-state-name="addressID" data-react-state-component-name="Address" defaultValue={self.state.addressID} value={self.state.addressID} onChange={self.onChange} />
                                </div> */}
                            </div>  
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">País</span>
                                    <select name="country" className="get-text required input-address-sec form-control" data-react-state-name="CountryCode" data-react-state-component-name="Address" defaultValue={self.state.CountryCode} onChange={self.onChange} disabled>
                                        <option value="">Selecciona tu país</option>
                                        {
                                            this.renderCountry()
                                        }
                                    </select>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Estado</span>
                                    {/* <input type="text" className="input-text get-text input-address-sec form-control" name="state" data-react-state-name="State" data-react-state-component-name="Address" defaultValue={self.state.State} value={self.state.State} onChange={self.onChange} /> */}                                    
                                    <select className="input-text get-text input-address-sec form-control" name="state" data-react-state-name="State" data-react-state-component-name="Address" defaultValue={this.state.State} value={self.state.selectedState} onChange={self.handleStateChange}>
                                    <option value="">Seleccione el estado</option>
                                        {self.state.states.map((state, index) => (
                                            <option key={index} value={state}>{state}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Ciudad</span>
                                    <select className="input-text get-text required input-address-sec form-control" name="City" data-react-state-name="City" data-react-state-component-name="Address" defaultValue={self.state.City}  value={this.state.selectedCity} onChange={this.handleCityChange}>
                                        <option value="">Seleccione la ciudad</option>
                                        {self.state.cities.map((city, index) => (
                                            <option key={index} value={city}>{city}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-xs-12 col-md-6">
                                    <span className="title lbl-profile">Código Postal</span>
                                    <input type="text" className="input-text get-text required input-address-sec" name="postal_code" data-react-state-name="PostCode" data-react-state-component-name="Address" defaultValue={self.state.PostCode} onChange={self.onChange} />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">                            
                            <button className="btn buttons-add-address btn-cancel-add-address" onClick={() => self.hideEditAddress()}>
                                Cancelar
                            </button>
                            <button className="btn buttons-add-address btn-add-address" id="updateAddress" onClick={(e) => self.updateAddress(e)}>
                                Agregar
                            </button>                                
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderDeleteAddressModal(){
        let self = this;
        return(
            <div id="modalRemove" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog delete-modal-content">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p>¿Desea eliminar la dirección?</p>
                        </div>
                        <div className="modal-footer">
                            <div className="btn-gray" data-dismiss="modal">Cancelar</div>
                            <div className="btn-green" id="btnRemove" onClick={(e) => self.doAddressDelete(e)}>Si</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        let self = this;
        const userDetail = self.props.user;
        var tipoCliente = 'B2B';
        if(userDetail) {
            if(userDetail.CustomFields) {
                if(userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario")) {
                    tipoCliente  = userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0];
                }
            }
        }        
        return (
            <React.Fragment>
                { this.renderAddAddressModal() }

                { this.renderEditAddressModal() }

                { this.renderDeleteAddressModal() }

                <div id="Address" className="tab-pane fade">
                    <div className="setting-address-box full-width" id="boxContainer">
                        <div className="pdc-boxs container-user-data">
                            <div className="lbl-type-of-Address">Direcciones de facturación</div>
                            <div id="addr-billing">
                            {
                                self.showAddressList(false)
                            }
                            </div>
                            <div className="lbl-type-of-Address">Direcciones de envío</div>
                            <div id="addr-shipping">
                            {
                                self.showAddressList(true)
                            }
                            </div>                                                       
                        </div>
                                     
                        {tipoCliente ==='B2C' ? (
                            <div className="row">
                                <div className="col-xs-12">
                                    <button type="button" className="btn btn-primary" data-toggle="modal" data-target="#modalAddAddress" onClick={() => self.resetAddAddress()}>
                                        Añadir nueva dirección
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="row">
                                <div className="col-xs-12">
                                </div>
                            </div>
                        )}
                        <AddressSettingsButton updateUserToOnboard={this.props.updateUserToOnboard} user={this.props.user}/>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

module.exports = AddressSettingsComponent;